module.exports = __webpack_public_path__ + "static/img/login_img.5457f216.png";